import { withErrorBoundary } from '@s4l/utils/hocs/withErrorBoundary'
import React, { useState } from 'react'
import { ListOfProperty } from '@s4l/stayforlong/property/domain/ListOfProperty'
import { useS4LContext } from '@s4l/react-context'
import { Typography } from '@s4l/ds'

import { PropertiesCarousel, PropertyCard } from '../../index'

import styles from './styles.module.css'

export interface ILastSeenProps {
  lastSeenPropertiesJSON: ReturnType<ListOfProperty['toJSON']>
  onPropertyClick?: (propertyId: string) => void
}

function LastSeen({ lastSeenPropertiesJSON, onPropertyClick }: Readonly<ILastSeenProps>) {
  const { i18n, domain } = useS4LContext()
  const [lastSeenProperties, setLastSeenProperties] = useState(() =>
    ListOfProperty.fromJSONOrEmpty({ json: lastSeenPropertiesJSON })
  )

  if (lastSeenProperties.isEmpty()) return null

  const handleRemoveClick = async (
    propertyId: ReturnType<ListOfProperty['toJSON']>['list'][number]['id']
  ) => {
    await domain.RemoveByIDLastSeenPropertyUseCase.execute({ id: propertyId })
    setLastSeenProperties(lastSeenProperties.removeById(propertyId))
  }

  return (
    <div className={styles.lastSeen} data-testid="last-seen" key={lastSeenProperties.length}>
      <Typography as="h5" variant="title" size="s" ellipsis>
        {i18n.formatMessage({ id: 'global.hotels-seen' })}
      </Typography>

      <PropertiesCarousel
        propertiesJSON={lastSeenProperties.toJSON()}
        onPropertyClick={onPropertyClick}
      >
        {/* eslint-disable-next-line @typescript-eslint/no-unused-vars */}
        {(property, _index) => (
          <PropertyCard.ActionRemove onClick={() => handleRemoveClick(property.id)} />
        )}
      </PropertiesCarousel>
    </div>
  )
}

LastSeen.displayName = 'LastSeen'
export default withErrorBoundary(LastSeen)
